import { ToastType } from '~/components/Global/Interactions/Toast/ToastType'
import { toast } from '~/utils'
import { useExtensionState } from '../../hooks/useExtensionState'
import { etestingExtension } from '../extension'
import { useEtestingReservation } from '../mutations/useEtestingReservation'

export const useEtestingLaunch = (): {
  isAvailable: boolean
  isPending: boolean
  launch: (applicantIds: number[]) => Promise<void>
} => {
  const { state } = useExtensionState(etestingExtension)
  const { mutateAsync: reserve, isPending } = useEtestingReservation()

  const launch = async (applicantIds: number[]): Promise<void> => {
    try {
      const { linkConnect } = await reserve(applicantIds)
      const target = window.open(linkConnect, '_blank')
      if (target === null) {
        toast(
          'Fenêtre bloquée',
          "Autorisez les popups pour ce site puis relancez l'action pour ouvrir le lien e-testing.",
          ToastType.Warning
        )
      }
    } catch {
      toast(
        'Erreur',
        "Le lien e-testing n'a pas pu être généré.",
        ToastType.Danger
      )
    }
  }

  return {
    isAvailable: state?.isEnabled === true && state.isConfigured,
    isPending,
    launch
  }
}
